import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { ModalFrameComponent } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.component';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { TableComponent } from 'src/app/components/shared/table/components/table/table.component';
import {
  ActiveCarryOverLoads,
  BagLinkDetails,
} from 'src/app/core/models/position-operations/carry-over-loads.model';
import { CarryOverLoadsUtils } from 'src/app/core/utils/carry-over-loads/carry-over-loads.utils';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import {
  COLUMN_CONFIG,
  ColumnIds,
  SMART_BAG_CONSTANTS,
  TableData,
} from './smart-bag-check-constants';

@Component({
  selector: 'app-smart-bag-check-component',
  imports: [ModalFrameComponent, TableComponent],
  templateUrl: './smart-bag-check-component.component.html',
  styleUrl: './smart-bag-check-component.component.scss',
})
export class SmartBagCheckComponentComponent implements OnInit {
  readonly CONSTANTS = SMART_BAG_CONSTANTS;
  readonly BUTTON_TYPES = BUTTON_TYPES;
  readonly COLUMN_CONFIG = COLUMN_CONFIG;
  readonly displayedColumn = Object.values(ColumnIds);

  tableData: TableData[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedLoad: ActiveCarryOverLoads;
      response: BagLinkDetails[];
      carryLoadsForm: FormGroup;
    },
    private dialogRef: MatDialogRef<SmartBagCheckComponentComponent>,
    private readonly carryOverLoadUtils: CarryOverLoadsUtils,
    private readonly commonUtils: CommonUtils,
  ) {}

  ngOnInit() {
    this.data?.response?.forEach((bagDetail) => {
      this.tableData.push({
        bag: bagDetail.bag,
        loadName: bagDetail.loadName,
      });
    });
  }

  leftButtonClick() {
    this.processAutoLink(false);
  }

  rightButtonClick() {
    this.processAutoLink(true);
  }

  processAutoLink(autoLinkAndClose: boolean) {
    this.commonUtils.updateLoadingModal(true);
    this.commonUtils.lockUpdateLoadingModal(true);

    this.carryOverLoadUtils
      .closeTheLoad(
        [this.data.selectedLoad],
        this.data.carryLoadsForm?.get('closeDate')?.value,
        this.data.carryLoadsForm?.get('closeTime')?.value,
        this.data.carryLoadsForm,
        0,
        false,
        this.data?.selectedLoad?.id,
        autoLinkAndClose,
      )
      .pipe(
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
          this.commonUtils.lockUpdateLoadingModal(false);
        }),
      )
      .subscribe((resp) => {
        if (resp?.code === 200) {
          this.commonUtils.updateBannerType(BANNER_TYPE.API_SUCCESS);
        }
        this.dialogRef.close(true);
      });
  }

  onClose() {
    this.dialogRef.close();
  }

  get getLeftButton() {
    return {
      type: BUTTON_TYPES.CANCEL_BUTTON,
      text: SMART_BAG_CONSTANTS.LEFT_BUTTON,
    };
  }

  get getRightButton() {
    return {
      text: SMART_BAG_CONSTANTS.RIGHT_BUTTON,
      imageSrc: '',
      type: BUTTON_TYPES.TEXT_BUTTON,
      disable: false,
    };
  }
}
